/** @format */
// @ts-nocheck

import { Button, Card, Col, Menu, Row, Spin } from "antd";
import Image from "next/image";
import axios from "axios";
import Link from "next/link";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { convert } from "html-to-text";
import type { GetStaticPaths } from "next";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import type { Article, Articles } from "../../../interfaces/articles";
import { getStaticProps } from "../../../methods/i18n";
import responsiveColumn from "../../../methods/responsiveColumn";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import Footer from "../../components/Footer";
// import Head from "next/head";
import SEO from "../../components/seo";
import { useTranslation } from "next-i18next";
import { HeadScriptTag } from "../../components/HeadScriptTag";
import type { CustomMenuItemType } from "../../../interfaces/menu";
import { replaceSpacesAndHyphensWithUnderscores } from "../../components/utils";

export { getStaticProps };

export const getStaticPaths: GetStaticPaths<{ slug: string }> = async () => {
	return {
		paths: [],
		fallback: "blocking",
	};
};

export default function PracticeArea() {
	const [areas, setAreas] = useState<Articles>();
	const [activeItem, setActiveItem] = useState(0);
	const subdata = [
		{
			id: 1067,
			title: "Administrative and Grand Jury Investigations",
			subtitle: [
				"Representation during Administrative and Grand Jury Investigations",
			],
		},
		{
			id: 1074,
			title: "Tax Related Offenses under the Internal Revenue Code",
			subtitle: [
				"Tax Evasion",
				"Willful Failure to Collect or Pay Over Tax",
				"Willful Failure to File Return, Supply Information or Pay Tax",
				"Subscribing to False Returns; Aiding and Abetting in the Preparation of False Returns",
				"Submitting Fraudulent Returns, Statements or Other False Documents",
				"Attempts to Interfere with the Administration of the Internal Revenue Laws",
				"Unlawful Disclosures",
			],
		},
		{
			id: 1075,
			title: "Tax Related Offenses under the Criminal Code",
			subtitle: [
				"Conspiracy to Defraud the United States",
				"False Statements",
				"False, Fictitious, or Fraudulent Claims",
				"Money Laundering",
				"Mail Fraud and Wire (electronic communication) Fraud",
				"Bribery",
				"Aiding and Abetting",
				"Failure to File Foreign Bank Account Reporting Form (FBAR)",
			],
		},
		{
			id: 1077,
			title: "Cash Transaction Reporting Requirement Offenses",
			subtitle: [
				"Reporting Requirements",
				"Failure to File Currency Transaction Reports and Related “Structuring” Violations",
			],
		},
		{
			id: 1079,
			title: "Tax-Bankruptcy Related Offenses under the Criminal Code",
			subtitle: ["Failure to File Foreign Bank Account Reporting Form (FBAR)"],
		},
	];
	const [subtiles, setsubtiles] = useState(0);
	const [subareas, setsubAreas] = useState<Articles>();

	const [selectedArea, setSelectedArea] = useState<Article>();
	const router = useRouter();
	const { slug } = router.query;
	const { locale } = router;
	const { t } = useTranslation([
		"breadcrumb_section",
		"criminal_tax_defense_group",
		"meta_tags"
	]);
	const setQuery = useMemo(() => {
		if (locale !== "en") {
			return `?lang=${locale}&`;
		} else {
			return "?";
		}
	}, [locale]);

	const generateMenuItems = (): CustomMenuItemType[] => {
		if (!areas) {
			return [];
		}

		const menuAreas = subdata.filter(
			(val) =>
				(areas || []).map((area) => area.title?.rendered).includes(val.title) &&
				(areas || []).map((area) => area.id).includes(val.id)
		);

		const menuItems: CustomMenuItemType[] = menuAreas.map((area) => {
			const mainCardTitle = area.title;
			// const id = area.id;
			// const matchingSubData = subdata.find(
			// 	(val) => val.title === mainCardTitle && val.id == id
			// );

			// if (matchingSubData) {
			// 	console.log({ matchingSubData, mainCardTitle });

			// }
			if (activeItem === area.id) {
				console.log({
					activeItem,
					subareas: subareas?.slice(0, subareas.length - 1),
				});
			}

			return {
				label: (
					<div style={{ display: "flex", flexDirection: "column" }}>
						<div
							style={{ display: "flex" }}
							onClick={() => {
								setsubtiles(
									mainCardTitle ===
										"Cash Transaction Reporting Requirement Offenses"
										? 67
										: mainCardTitle ===
											"Tax Related Offenses under the Internal Revenue Code"
											? 65
											: mainCardTitle ===
												"Tax Related Offenses under the Criminal Code"
												? 66
												: mainCardTitle ===
													"Administrative and Grand Jury Investigations"
													? 75
													: mainCardTitle ===
														"Tax-Bankruptcy Related Offenses under the Criminal Code"
														? 76
														: 0
								);
								setActiveItem(activeItem === area?.id ? 0 : area?.id);
							}}>
							<div
								style={{
									display: "inline-block",
									marginRight: 20,
								}}>
								{
									<Image
										width={10}
										height={10}
										style={{
											marginLeft: 10,
											marginBottom: 5,
										}}
										//preview={false}
										src={activeItem === area.id ? "/up.svg" : "/down.svg"}
										alt={activeItem === area.id ? "up" : "down"}
									/>
								}
							</div>

							{area.title}
						</div>
						{activeItem === area.id && (
							<>
								{(subareas?.slice(0, subareas.length - 1) || [])
									.reverse()
									.map((val) => (
										<Menu.Item key={`submenu-${val.id}`}>
											<Link
												style={{ fontSize: 16 }}
												href={`/criminal-tax-defense/${val.slug}`}>
												{val.title.rendered}
											</Link>
										</Menu.Item>
									))}
							</>
						)}
					</div>
				),
				key: area.id,
				style: {
					whiteSpace: "normal",
					height: "auto",
					lineHeight: 1.6,
					padding: "12px 24px",
				},
				type: "item",
			};

			// return null;
		});

		return menuItems;
		// 	.filter(
		// 	(item): item is CustomMenuItemType => item !== null
		// ) as CustomMenuItemType[];
	};

	const menuItems = generateMenuItems();
	const [locationtypeData, setLocationTypeData] = useState<any>();
	const [locationData, setLocationData] = useState<any>();
	const [isMapMounted, setIsMapMounted] = useState<any>(true);

	const fetchAreas = async () => {
		try {
			const r = await axios({
				url: `https://wp.taxworkoutgroup.com/wp-json/wp/v2/practice_areas${setQuery}_embed&per_page=100`,
				method: "get",
			});
			console.log(r);
			setAreas(
				r.data?.sort((a: any, b: any) => a.acf.priority - b.acf.priority)
			);
			setSelectedArea(
				(r.data as Articles)?.find((article) => article.slug === slug)
			);
			setLocationData(r?.data);
		} catch (e) {
			console.log(e);
		}
	};
	const fetchSubArticles = async () => {
		try {
			const r = await axios({
				url: `https://wp.taxworkoutgroup.com/wp-json/wp/v2/practice_areas?_embed&per_page=100&tags=${subtiles}&${locale != "en" ? `lang=${locale}` : ""
					}`,
				method: "get",
			});
			console.log("This is response", r);
			setsubAreas(
				r.data?.sort((a: any, b: any) => a.acf.priority - b.acf.priority)
			);
		} catch (e) {
			console.log(e);
		}
	};

	useEffect(() => {
		fetchAreas();
	}, [locale]);
	useEffect(() => {
		fetchSubArticles();
	}, [subtiles]);
	useEffect(() => {
		if (!areas) return;
		setSelectedArea(areas.find((article) => article?.slug === slug));
	}, [slug, areas]);

	useEffect(() => {
		//FIND ALL LIs
		const lis = document.querySelectorAll("li");
		lis?.forEach((li) => {
			if (li.style.listStyleType === "none") li.classList.add("no-before");
		});
	}, [selectedArea]);

	const [modifiedLocationTitle, setModifiedLocationTitle] = useState<string>("");
	const [cleanedBreadcrumbLabel, setCleanedBreadcrumbLabel] = useState<string>("");

	useEffect(() => {
		if (slug) {
			const modified = replaceSpacesAndHyphensWithUnderscores(slug as string);
			setModifiedLocationTitle(modified);
		}
	}, [slug]);

	useEffect(() => {
		if (locationData?.length > 0) {
			const filteredLocationsData = locationData?.find(
				(locationValue: any) => locationValue?.slug === slug
			);
			setLocationTypeData(filteredLocationsData);
			setIsMapMounted(false);
		}
	}, [slug, locationData]);

	useEffect(() => {
		let timer: any;
		if (!isMapMounted) {
			timer = setTimeout(() => setIsMapMounted(true), 500);
		}
		return () => clearTimeout(timer);
	}, [isMapMounted]);

	const modifiedLocation: string = replaceSpacesAndHyphensWithUnderscores(
		slug as string
	);

	// const breadcrumbLabel = selectedArea
	// 	? t(`${modifiedLocation}`, { ns: "meta_tags" })
	// 	: "Tax Motivated Bankruptcy Filings";

	useEffect(() => {
		const cleanedLabel = breadcrumbLabel.replace("#038;", "");
		console.log("cleanedBreadcrumbLabel:", cleanedLabel);
		setCleanedBreadcrumbLabel(cleanedLabel);
		const title = selectedArea ? t(`${modifiedLocation}`, { ns: "meta_tags" }) : t("home");
		const description = selectedArea
			? t(`${modifiedLocation}_desc`, { ns: "meta_tags" })
			: t("home_desc");
	}, [modifiedLocation, selectedArea]);

	const breadcrumbLabel = selectedArea ? selectedArea?.title.rendered : "Tax Motivated Bankruptcy Filings";
	const title = selectedArea ? `${selectedArea?.title.rendered} | Tax Controversy | Practice Areas | TaxWorkoutGroup` : t("meta_tags:home");
	// const description = t("home_desc");
	const description = t("meta_tags:home_desc");
	const keywords = "Tax,Tax Bankruptcy ,Tax Controversy";
	// const ogImage = "https://www.example.com/static/images/og-image.jpg";
	const ogType = "website";
	const canonicalURL = `https://taxworkoutgroup.com/criminal-tax-defense/${(locationtypeData?.slug as string) ?? ""
		}`;


	return (
		<>
			<SEO
				title={selectedArea ? t(`${modifiedLocation}`, { ns: "meta_tags" }) : t("home")}
				description={description}
				keywords={keywords}
				ogType={ogType}
				canonicalURL={canonicalURL}
			/>
			<HeadScriptTag />
			<CustomBreadcrumb
				items={[
					{
						label: t("breadcrumb_section:home"),
						href: "/",
					},
					{
						label: t("controversy:practice"),
						href: "/practice-areas",
					},
					{
						label: t("criminal_tax_defense_group:controversy"),
						href: "/criminal-tax-defense",
					},
					{
						label: cleanedBreadcrumbLabel || "Default Label",
						href: `/criminal-tax-defense/${encodeURI(selectedArea?.slug as string)}`,
					},
				]}
			/>
			<Spin spinning={selectedArea ? false : true}>
				<Row
					justify={"center"}
					style={{ paddingTop: 30, paddingBottom: 30, lineHeight: 1.5 }}
					gutter={[30, 30]}>
					<Col
						{...responsiveColumn([10, 13, 16, 23, 23, 23])}
						className='practice_article'>
						<div className='section_title'>
							<h1 className='section_title'>
								{selectedArea && convert(selectedArea?.title.rendered)}
							</h1>
						</div>
						<div
							className='wp criminal-tax-defence-post-content-area'
							style={{ marginTop: 30 }}
							dangerouslySetInnerHTML={{
								__html: selectedArea?.content.rendered ?? "",
							}}></div>
						<Link href='/new-clients-intake-overview'>
							<Button
								size='large'
								style={{
									background: "#254486",
									border: "#254486",
									color: "#fff",
									padding: "0 60px",
									fontSize: 15,
									margin: "0 auto",
									display: "table",
								}}
								className='stext4'>
								Schedule A Free Tax Case Evaluation
							</Button>
						</Link>
					</Col>
					<Col {...responsiveColumn([6, 6, 7, 23, 23, 23])}>
						<Card
							headStyle={{
								whiteSpace: "normal",
								textOverflow: "unset",
								padding: "24px 16px",
							}}
							title={
								<div
									style={{
										textAlign: "center",
										fontSize: 24,
										fontWeight: 600,
										lineHeight: 1.3,
									}}>
									Criminal Tax Defense <br />
									Practice Areas
								</div>
							}
							style={{ boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.25)" }}>
							<Menu
								defaultSelectedKeys={[
									encodeURI(selectedArea?.title.rendered ?? "0"),
								]}
								triggerSubMenuAction='click' // Disable highlighting on click
								mode='inline'
								disabledOverflow={true}
								style={{ border: 0 }}
								items={menuItems ?? []}
							/>
						</Card>
					</Col>
				</Row>
			</Spin>
			<p className="invisible-number">(866) 845-7080</p>

			<Footer />
		</>
	);
}
